import clsx from 'clsx';
import { memo } from 'react';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

export const HowTheyScored = ({ data }) => {
  const t = useTranslateFn();

  const other = data && data.length && data[3];
  const head = data && data.length && data[2];
  const right = data && data.length && data[1];
  const left = data && data.length && data[0];

  return (
    <div className={styles.tsScored} data-testid='how-they-scored'>
      <div className={styles.tsScoredTitle}>{t('stats_how_were_scored')}</div>

      <div className={clsx(styles.tsScoredDatas, 'ts-scored__datas')}>
        <div className={clsx(styles.tsScoredOther, 'ts-scored-other', { [styles['disabled']]: !other })}>
          <div className={styles.tsScoredData}>{other}</div>
          <div className={styles.tsScoredLabel}>{t('stats_goals_Other')}</div>
        </div>

        <div className={clsx(styles.tsScoredHead, 'ts-scored-head', { [styles['disabled']]: !head })}>
          <div className={styles.tsScoredData}>{head}</div>
          <div className={styles.tsScoredLabel}>{t('injury_head')}</div>
        </div>

        <div className={clsx(styles.tsScoredRight, 'ts-scored-right', { [styles['disabled']]: !right })}>
          <div className={styles.tsScoredData}>{right}</div>
          <div className={styles.tsScoredLabel}>{t('stats_goals_RightFoot')}</div>
        </div>

        <div className={clsx(styles.tsScoredLeft, 'ts-scored-left', { [styles['disabled']]: !left })}>
          <div className={styles.tsScoredData}>{left}</div>
          <div className={styles.tsScoredLabel}>{t('stats_goals_LeftFoot')}</div>
        </div>
      </div>
    </div>
  );
};

export default memo(HowTheyScored);
